import { RefObject, useEffect } from 'react';

let useParticles = (canvasRef: RefObject<HTMLCanvasElement>, contentRef: RefObject<HTMLElement>) => {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    useEffect(() => {}, [canvasRef, contentRef]);
};

// particle-explosions падает на сервере ReferenceError: window is not defined
if (typeof window !== 'undefined') {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    useParticles = require('./useParticles').useParticles;
}

export { useParticles };
